/**
 * @generated SignedSource<<221ed427f9206b5e1e056e25cbe739c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type FormResponseState = "DRAFT" | "SUBMITTED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type FormResponses_content$data = {
  readonly isClosed?: boolean;
  readonly questions?: ReadonlyArray<{
    readonly definition: {
      readonly __typename: "CustomField__Checkboxes";
      readonly id: string;
      readonly options: ReadonlyArray<{
        readonly text: string;
        readonly value: string;
      }>;
    } | {
      readonly __typename: "CustomField__Date";
      readonly id: string;
    } | {
      readonly __typename: "CustomField__DateTime";
      readonly id: string;
    } | {
      readonly __typename: "CustomField__Email";
      readonly id: string;
    } | {
      readonly __typename: "CustomField__Link";
      readonly id: string;
    } | {
      readonly __typename: "CustomField__MultipleChoice";
      readonly id: string;
      readonly options: ReadonlyArray<{
        readonly text: string;
        readonly value: string;
      }>;
    } | {
      readonly __typename: "CustomField__Numeric";
      readonly id: string;
    } | {
      readonly __typename: "CustomField__PhoneNumber";
      readonly id: string;
    } | {
      readonly __typename: "CustomField__String";
      readonly id: string;
    } | {
      readonly __typename: "CustomField__Time";
      readonly id: string;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
    readonly id: string;
    readonly text: string;
  }>;
  readonly responses?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly answers: ReadonlyArray<{
          readonly __typename: "FormResponseAnswer";
          readonly id: string;
          readonly questionId: string;
          readonly value: {
            readonly __typename: "CustomValue__Checkboxes";
            readonly checkboxValues: ReadonlyArray<string> | null;
          } | {
            readonly __typename: "CustomValue__Date";
            readonly dateValue: DateString  | null;
          } | {
            readonly __typename: "CustomValue__DateTime";
            readonly dateTimeValue: ISO8601DateTimeString | null;
          } | {
            readonly __typename: "CustomValue__Email";
            readonly emailValue: string | null;
          } | {
            readonly __typename: "CustomValue__Link";
            readonly linkValue: string | null;
          } | {
            readonly __typename: "CustomValue__MultipleChoice";
            readonly multipleChoiceValue: string | null;
          } | {
            readonly __typename: "CustomValue__Numeric";
            readonly numericValue: number | null;
          } | {
            readonly __typename: "CustomValue__PhoneNumber";
            readonly phoneNumberValue: string | null;
          } | {
            readonly __typename: "CustomValue__String";
            readonly stringValue: string | null;
          } | {
            readonly __typename: "CustomValue__Time";
            readonly timeValue: TimeOfDayString | null;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null;
        }>;
        readonly id: string;
        readonly respondedAt: ISO8601DateTimeString | null;
        readonly responder: {
          readonly name: string;
        };
        readonly state: FormResponseState;
      } | null;
    }>;
  };
  readonly title?: string;
  readonly " $fragmentType": "FormResponses_content";
};
export type FormResponses_content$key = {
  readonly " $data"?: FormResponses_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"FormResponses_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomField__FieldOption",
    "kind": "LinkedField",
    "name": "options",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      },
      (v1/*: any*/)
    ],
    "storageKey": null
  }
],
v4 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FormResponses_content",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isClosed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FormQuestion",
          "kind": "LinkedField",
          "name": "questions",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "definition",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v3/*: any*/),
                  "type": "CustomField__Checkboxes",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v4/*: any*/),
                  "type": "CustomField__Numeric",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v4/*: any*/),
                  "type": "CustomField__String",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v3/*: any*/),
                  "type": "CustomField__MultipleChoice",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v4/*: any*/),
                  "type": "CustomField__Date",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v4/*: any*/),
                  "type": "CustomField__Time",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v4/*: any*/),
                  "type": "CustomField__DateTime",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v4/*: any*/),
                  "type": "CustomField__Email",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v4/*: any*/),
                  "type": "CustomField__PhoneNumber",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v4/*: any*/),
                  "type": "CustomField__Link",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FormResponseConnection",
          "kind": "LinkedField",
          "name": "responses",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FormResponseEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormResponse",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "respondedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "state",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Member",
                      "kind": "LinkedField",
                      "name": "responder",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FormResponseAnswer",
                      "kind": "LinkedField",
                      "name": "answers",
                      "plural": true,
                      "selections": [
                        (v2/*: any*/),
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "questionId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "value",
                          "plural": false,
                          "selections": [
                            (v2/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": "checkboxValues",
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "value",
                                  "storageKey": null
                                }
                              ],
                              "type": "CustomValue__Checkboxes",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": "stringValue",
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "value",
                                  "storageKey": null
                                }
                              ],
                              "type": "CustomValue__String",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": "numericValue",
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "value",
                                  "storageKey": null
                                }
                              ],
                              "type": "CustomValue__Numeric",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": "multipleChoiceValue",
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "value",
                                  "storageKey": null
                                }
                              ],
                              "type": "CustomValue__MultipleChoice",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": "dateValue",
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "value",
                                  "storageKey": null
                                }
                              ],
                              "type": "CustomValue__Date",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": "timeValue",
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "value",
                                  "storageKey": null
                                }
                              ],
                              "type": "CustomValue__Time",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": "dateTimeValue",
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "value",
                                  "storageKey": null
                                }
                              ],
                              "type": "CustomValue__DateTime",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": "emailValue",
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "value",
                                  "storageKey": null
                                }
                              ],
                              "type": "CustomValue__Email",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": "phoneNumberValue",
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "value",
                                  "storageKey": null
                                }
                              ],
                              "type": "CustomValue__PhoneNumber",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": "linkValue",
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "value",
                                  "storageKey": null
                                }
                              ],
                              "type": "CustomValue__Link",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Form",
      "abstractKey": null
    }
  ],
  "type": "FolderItemContent",
  "abstractKey": "__isFolderItemContent"
};
})();

(node as any).hash = "f47e03b04f6842507af641d5005fddd2";

export default node;
